import { FC, useState, useEffect, useCallback } from 'react';
import { Modal } from 'antd';
import { Drawer } from '@pro/lib/Drawer';
import styles from './index.module.less';
import { FeatureForm } from '@pro/feature/FeatureForm';
import { useCalendlyPopup } from 'base/hooks/useCalendlyPopup';
import { features } from 'pro/config/pages/contact-us';
import { useStoreState } from 'base/store';
import cn from 'classnames';

export const FixedCalendly: FC = () => {
    const [visible, setVisible] = useState<boolean>(true);
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { openCalendly } = useCalendlyPopup();
    const { ua: { isPhone } } = useStoreState('rootStore');

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setVisible(true);
    //     }, 10000);
    //     return () => clearTimeout(timer);
    // }, []);

    const handleIconClick = () => {
        setModalVisible(true);
    };

    const SUBMIT_EVENT = 'FIXED_CALENDLY_SUBMIT_SUCCESS';

    const handleFormSuccess = useCallback((e: CustomEvent) => {
        const formData = e.detail;
        setModalVisible(false);
        // 拉起 Calendly Popup 并自动填充
        openCalendly(formData);
    }, [openCalendly]);

    useEffect(() => {
        if (modalVisible) {
            window.addEventListener(SUBMIT_EVENT, handleFormSuccess as EventListener);
        } else {
            window.removeEventListener(SUBMIT_EVENT, handleFormSuccess as EventListener);
        }
        return () => {
            window.removeEventListener(SUBMIT_EVENT, handleFormSuccess as EventListener);
        };
    }, [modalVisible, handleFormSuccess]);

    const contactFormFeature = features.find((f: any) => f.type === 'form');
    if (!contactFormFeature) return null;

    // 定制表单配置
    const customFeature = {
        ...contactFormFeature,
        description: '',
        config: {
            ...contactFormFeature.config,
            submitEvent: SUBMIT_EVENT,
            buttonProps: {
                ...contactFormFeature.config.buttonProps,
                children: 'Start Booking',
                className: styles.submitBtn
            }
        }
    };

    const renderContent = () => (
        <div className={styles.modalContent}>
            <h2 className={styles.title}>{'Before we schedule your meeting'}</h2>
            <p className={styles.description}>
                {'To help us better understand your needs and prepare for the meeting, we’ll ask you to share a few basic details before booking.'}
            </p>
            <div className={styles.formWrapper}>
                <FeatureForm
                    feature={customFeature}
                />
            </div>
        </div>
    );

    return (
        <>
            <div 
                className={cn(styles.fixedIcon, { [styles.visible]: visible })}
                onClick={handleIconClick}
            >
                <div className={styles.iconContent}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 2V6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8 2V6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M3 10H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <div className={styles.iconText}>Book a Meeting</div>
                </div>
            </div>

            {isPhone ? (
                <Drawer
                    height={'95%'}
                    placement="bottom"
                    visible={modalVisible}
                    onClose={() => setModalVisible(false)}
                    className={styles.contactDrawer}
                >
                    {renderContent()}
                </Drawer>
            ) : (
                <Modal
                    open={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    footer={null}
                    width={1000}
                    centered
                    className={styles.contactModal}
                    closeIcon={
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13 13M1 13L13 1" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                    destroyOnClose
                >
                    {renderContent()}
                </Modal>
            )}
        </>
    );
};
